<template>
  <v-dialog v-model="dialog" max-width="1024">
    <template v-slot:activator="{on}">
      <slot name="button" v-bind:on="on">
        <v-btn v-on="on" color="primary" :small="small">
          Выбрать
        </v-btn>
      </slot>
    </template>

    <v-card>
      <v-card-title>Выбор контрагента</v-card-title>
      <v-card-text>
        <select-company :dense="true" v-model="company" @change="onChange"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" text @click="dialog = false">
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SelectCompany from "@/components/Select/SelectCompany";

export default {
  name: "SelectCompanyDialog",
  components: {SelectCompany},
  props: {
    small: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      company: null
    }
  },
  methods: {
    onChange(){
      this.$emit("input", this.company)
      this.$emit("change", this.company)
    }
  }
}
</script>

<style scoped>

</style>